/**
 * Canonical form of a device serial.
 *
 * `devices.slno` is Postgres `char(16)`. Real serials are 12 characters, so the
 * stored value is blank-padded and every client that reads the column directly
 * gets `"220022000030    "`. The two sources this app consumes disagree about
 * that:
 *
 *   REST  - the API's Device model rtrims char columns when a model is
 *           retrieved, so the device list carries `"220022000030"`.
 *   MQTT  - the gateway publishes the raw database value, so the payload
 *           carries the padding.
 *
 * Comparing those two directly never matches, which silently freezes the live
 * map: positions keep arriving and decrypting, and every lookup that tries to
 * attach one to a device misses. Nothing errors, so the only visible symptom is
 * that markers stop moving while the connection indicator stays green.
 *
 * Numbers matter too: a serial arrives as a number in some payloads and a
 * string in others, and `String()` alone was already needed for that.
 */
export function normalizeSerial(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
}

/** True when two serials refer to the same device, whatever their padding or type. */
export function sameSerial(a, b) {
    const left = normalizeSerial(a);
    return left !== '' && left === normalizeSerial(b);
}
